export default __webpack_public_path__ + "static/media/bite.aea7caff.mp3";